module.exports = __webpack_public_path__ + "assets/fonts/iconfont.5230aa24.ttf";